/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import DateTimePickerSplitted from '/client/src/components/dateTimePicker/dateTimePickerSplitted';
type PropsType = {
  beginTimeUtc: string,
  endTimeUtc: string,
  onEventBeginTimeChange: (string) => void,
  onEventEndTimeChange: (string) => void
};

const EventDates = ({
  beginTimeUtc,
  endTimeUtc,
  onEventBeginTimeChange,
  onEventEndTimeChange
}: PropsType): React.Element<'div'> => {
  return (
    <div className="event-dates-wr">
        <div
          className="form-group SimpleInput"
          onBlur={(): any => {
            const el = document.querySelector('.date');

            el.parentNode.parentNode.style.zIndex = 9;
          }}
          onFocus={(): any => {
            const el = document.querySelector('.date');

            el.parentNode.parentNode.style.zIndex = 99999;
          }}
        >
          <label>Event Starts</label>
              <div
                className="form-group"
                style={{
                  position: 'relative',
                  zIndex: 9
                }}
              >
                <div className="date">
                  <DateTimePickerSplitted
                    date={beginTimeUtc}
                    cb={(date: string) => {
                      onEventBeginTimeChange(date);
                    }}
                  />
                </div>

                <div
                  className='dateValidationMsg'
                  style={{
                    display: 'none',
                    color: 'red'
                  }}
                >
                  Start date can't be after End date
                </div>
          </div>
        </div>

        <div
          className="form-group SimpleInput"
          onBlur={(): any => {
            const el = document.querySelector('.e_date');

            el.parentNode.parentNode.style.zIndex = 9;
          }}
          onFocus={(): any => {
            const el = document.querySelector('.e_date');

            el.parentNode.parentNode.style.zIndex = 99999;
          }}
        >
          <label>Event Ends</label>
          <div>
              <div className="form-group">
                <div className="date e_date">
                  <DateTimePickerSplitted
                    date={endTimeUtc}
                    cb={(date: string) => {
                      onEventEndTimeChange(date);
                    }}
                  />
                </div>

                <div
                  className='e_dateValidationMsg'
                  style={{
                    display: 'none',
                    color: 'red'
                  }}
                >
                  End date can't be before Start date
                </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default EventDates;
